export default {
      id: "ic_match_card_search-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_match_card_search-usage",
      toString: function () {
        return this.url;
      }
    }